import gql from 'graphql-tag';
/* Get all Tickets based on Job Id  that's present */

import { TicketDetails } from './index';
import { LeaseInputLeaseFragment } from '../../fields/LeaseInput';
import { OperatorInputOperatorFragment } from '../../fields/OperatorInput';

const JobUpdateLeaseQuery = gql`
  mutation JobUpdateLease($input: JobUpdateLeaseInput!) {
    job_update_lease(input: $input) {
      id
      lease {
        id
        lookup {
          ...LeaseInputLease
        }
        operator {
          id
          lookup {
            ...OperatorInputOperatorLookup
          }
        }
      }
      tickets {
        edges {
          node {
            ...TicketDetails
          }
        }
      }
    }
  }
  ${TicketDetails}
  ${LeaseInputLeaseFragment}
  ${OperatorInputOperatorFragment}
`;

export const updateJobsLeaseMutationGQL = async (client, jobId, leaseId) => {
  const variables = {
    input: {
      job_id: jobId,
      lease_id: leaseId,
    },
  };

  const options = {
    mutation: JobUpdateLeaseQuery,
    variables,
  };

  return client.mutate(options);
};
